import { Typography } from '@mui/material';

import { CurrencyCode } from 'further-types/lp/vehicle';
import ConfirmDialog from 'further-ui/components/ConfirmDialog';
import FormField from 'further-ui/components/FormField';
import { Column, Divider, Row } from 'further-ui/components/Layout';
import NumberInput from 'further-ui/components/NumberInput';
import StaticField from 'further-ui/components/StaticField';
import { numberToCurrencyString } from 'further-ui/utils';
import { round } from 'lodash';
import { useState } from 'react';

type Props = {
  onClose: () => void;
  onSplit: (amount: number) => void;
  initialSplitAmount?: number;
  transactionUnreconciledAmountTcy: number;
  currency?: CurrencyCode;
};

const SplitTransactionDialog: React.FC<Props> = ({
  onClose,
  onSplit,
  transactionUnreconciledAmountTcy,
  initialSplitAmount,
  currency,
}) => {
  const [amountToSplit, setAmountToSplit] = useState(initialSplitAmount ?? 0);

  const handleSplit = () => {
    onSplit(amountToSplit);
  };

  return (
    <ConfirmDialog
      open
      onClose={onClose}
      maxWidth="sm"
      title="Split transaction"
      content={
        <Column spacing="md">
          <Typography variant="body2">
            Split transactions if you need to record a part payment.
          </Typography>
          <Column spacing="sm">
            <StaticField label="Balance" layout="horizontal">
              <Row justify="flex-end">
                {numberToCurrencyString(transactionUnreconciledAmountTcy, {
                  currency,
                })}
              </Row>
            </StaticField>
            <FormField label="Part payment" layout="horizontal" labelColorLight>
              <Row justify="flex-end">
                <NumberInput
                  decimals={2}
                  fixedDecimalScale
                  min={0}
                  max={transactionUnreconciledAmountTcy}
                  placeholder="Enter amount"
                  currencyStartAdornment
                  value={amountToSplit}
                  currency={currency}
                  onChange={(value) => {
                    setAmountToSplit(value ?? 0);
                  }}
                  textAlign="right"
                />
              </Row>
            </FormField>
            <Divider />
            <StaticField label="Remaining amount" layout="horizontal">
              <Row justify="flex-end">
                {numberToCurrencyString(
                  round(transactionUnreconciledAmountTcy - amountToSplit, 2),
                  {
                    currency,
                  },
                )}
              </Row>
            </StaticField>
          </Column>
        </Column>
      }
      actions={{
        confirm: {
          onClick: handleSplit,
          label: 'Split transaction',
        },
        cancel: {
          onClick: onClose,
          label: 'Cancel',
        },
      }}
    />
  );
};

export default SplitTransactionDialog;
